// extracted by mini-css-extract-plugin
export default {"component":"b2SHlU","rating":"c2SHlU","bar":"d2SHlU","great":"e2SHlU","good":"f2SHlU","fair":"g2SHlU","poor":"h2SHlU","selected":"i2SHlU"};